import { brand } from "../brand"

// Single source of truth for the marketed module names (see TLSCare-LandingPage featuresSection.tsx).
export const CARE_RECORD_MODULES = [
  { slug: "care-plan", label: "Digital Care Plan", icon: "Assignment", permission: "accessClientCareplan" },
  { slug: "emar", label: "EMAR", icon: "MedicalServices", permission: "accessClientEMAR" },
  { slug: "medication", label: "Medication Management", icon: "Medication", permission: "accessClientMedication" },
  { slug: "risk-assessment", label: "Risk Assessment", icon: "GppMaybe", permission: "accessClientRiskassessments" },
  { slug: "custom-forms", label: "Custom Forms", icon: "ListAlt", permission: "accessClientAdditionalForm" },
]

export const CARE_RECORDS_LABEL = "Care Records"
// Care Records navigation and the renamed labels are TLScare only; gpscare keeps its original names.
export const CARE_RECORDS_ENABLED = brand.careRecordsNav
export const SHIFT_MANAGEMENT_LABEL = CARE_RECORDS_ENABLED ? "Shift Management" : "Schedule"

const byLabel = Object.fromEntries(CARE_RECORD_MODULES.map((m) => [m.slug, m.label]))

// Client-profile tab names. Keep in sync with CARE_RECORD_MODULES; the tab doubles as the ?tab= deep-link value.
export const CLIENT_TAB = CARE_RECORDS_ENABLED
  ? {
      carePlan: byLabel["care-plan"],
      emar: byLabel["emar"],
      medication: byLabel["medication"],
      riskAssessment: byLabel["risk-assessment"],
      customForms: byLabel["custom-forms"],
    }
  : {
      carePlan: "Care Plan",
      emar: "EMAR",
      medication: "Medication",
      riskAssessment: "Risk Assessments",
      customForms: "Additional Forms",
    }

export const careRecordClientPath = (clientId, module) =>
  `/team/clients/${clientId}?tab=${encodeURIComponent(module.label)}`

// Modules the current user may open (needs the client list to pick a client, plus the module's own permission).
export const permittedCareRecordModules = (permissions) =>
  CARE_RECORDS_ENABLED && permissions.accessClientList ? CARE_RECORD_MODULES.filter((m) => permissions[m.permission]) : []
